import React, { Component } from 'react'
import { Link } from 'react-router'
import PriceChanger from './PriceChanger'
import ChanceChanger from './ChanceChanger'
import ModeChanger from './ModeChanger'
import ChanceNeighborhoodList from './ChanceNeighborhoodList'
import PriceNeighborhoodList from './PriceNeighborhoodList'
import PriceFocusChanger from './PriceFocusChangerFix'
import ProbabilityFocusChanger from './ProbabilityFocusChanger'
import NeighborhoodFocus from './NeighborhoodFocus'
import NeighborhoodFocus2 from './NeighborhoodFocus2'
import QuestionPrice from './QuestionPrice'
import QuestionProb from './QuestionProb'
import BoroughFilter from './BoroughFilter'
import QuestionPriceList from './QuestionPriceList'
import QuestionProbList from './QuestionProbList'
import HexFocus from './HexFocus'

const Sidebar2 = ({neighborhoods, neighborhoods_samples, active_year, changeActiveYear, active_price, active_probability, changeActivePrice, formatters, active_mode, changeActiveMode, changeActiveProbability, changePriceFocus, price_focus, active_neighborhood, probability_focus, changeProbabilityFocus, setActiveNeighborhood, closeHexFocus, closeNeighborhoodFocus, interpolators, setBoroughFilter, borough_filter, active_hex, show_roads, setShowRoads, setExplainer, browser_width, mobile_toggle, toggleMobile, mobile_show, changeMobileShow}) => {

  let filtered_neighborhoods = neighborhoods;
  if (borough_filter) {
    filtered_neighborhoods = neighborhoods.filter((n) => n.properties.borough === borough_filter ? true : false);
  }

  let top_space = 144;

  const handleModeClick = (new_mode) => {
    changeActiveMode(new_mode);
  }

  const handleRoadsClick = () => {
    setShowRoads(!show_roads);
  }

  const handleExplainerClick = () => {
    setExplainer(true);
  }

  const handleToggleClick = () => {
    toggleMobile(!mobile_toggle);
  }

  const handleMobileShowClick = (value) => {
    changeMobileShow(value)
  }

  let mobile = false;
  if (browser_width < 451) mobile = true;

  if (mobile) top_space = 144 + 35;

  let toggle_tab = "";
  let toggle_transform = "";
  let toggle_text = "×";
  if (browser_width < 801 && browser_width > 450) {
    if (!mobile_toggle) {
      toggle_transform = "translate(-360px,0)";
      toggle_text = <span className="relative" style={{top: '-0.2rem'}}>≡</span>;
    }
    toggle_tab = <div className="absolute hover pointer center bg-white border-right border-bottom right-0 top-0"
      title="Toggle sidebar"
      style={{
        width: '2.5rem',
        right: '-2.5rem',
        height: '2.4rem',
        fontSize: '2rem',
        lineHeight: '2.3rem'
      }}
      onClick={handleToggleClick.bind(this)}
      >{toggle_text}</div>
  }

  return (
    <div>
      <div className="flex ModeToggle nav-shadow">
        <div className="py1 px2 uppercase h6"
          style={{
            paddingTop: '0.7rem',
            paddingBottom: '0.3rem',
            paddingLeft: '0.75rem',
            paddingRight: '0.75rem'
          }}
        >Mode:</div>
        <div onClick={handleModeClick.bind(this, 'Chance')} className={"ModeItem py1 px2 pointer hover border-right " + (active_mode==='Chance' ? 'active' : '')}>Probability</div>
        <div onClick={handleModeClick.bind(this, 'Price')} className={"ModeItem py1 pointer px2 hover " + (active_mode==='Price' ? 'active' : '')}>Price</div>
      </div>
      {!(mobile && active_neighborhood) ? (
        <div className="StyleToggle py1 hover-light-gray px2 nav-shadow no-select" onClick={handleRoadsClick.bind(this)}>
          <input type="checkbox" readOnly checked={show_roads} /> Show Roads
        </div>
      ) : null}
      <div id="Sidebar"
        style={{
          paddingTop: top_space,
          transform: toggle_transform
        }}
      >
        <div className="fixed left-0 top-0 bg-white sidebar-width"
          style={{
            zIndex: 11
          }}
        >
          {toggle_tab}
          <div className="h5 border-bottom flex relative space-between">
            <Link className="block py1 bold px2 logo-link" to="/probability/1000000-50/2016/all_boroughs/all_neighborhoods">Probabilistic Real Estate</Link>
            <div className="bg-white h5 center no-select hover pointer absolute"
              onClick={handleExplainerClick.bind(this)}
              style={{
                width: '1.25rem',
                height: '1.25rem',
                right: '0.5rem',
                lineHeight: '1.25rem',
                fontSize: '1rem',
                fontWeight: '900',
                borderRadius: '50%',
                top: '0.5rem',
                marginRight: '0.5rem',
                background: '#efefef'
              }}
            >
              ?
            </div>
          </div>
          {active_mode === 'Price' ? (
            <QuestionProb
              active_probability={active_probability}
              changeActiveProbability={changeActiveProbability}
              formatters={formatters}
            />
          ) : (
            <QuestionPrice
              active_price={active_price}
              changeActivePrice={changeActivePrice}
              formatters={formatters}
            />
          )}
          {mobile ? (
            <div className="h6 flex border-bottom">
              <div className="px2 py1 uppercase">Show:</div>
              <div className={"center px2 py1 ButtonItem " + (mobile_show === 'map' ? 'active' : null)} onClick={handleMobileShowClick.bind(this,'map')}>Map</div>
              <div className={"center px2 py1 ButtonItem " + (mobile_show === 'info' ? 'active' : null)} onClick={handleMobileShowClick.bind(this,'info')}>Info</div>
            </div>
          ) : null}
        </div>
        {active_hex && (!mobile || mobile_show === 'info') ? (
          <div className="relative">
            <HexFocus
              active_neighborhood={active_neighborhood}
              active_mode={active_mode}
              formatters={formatters}
              active_year={active_year}
              active_price={active_price}
              active_probability={active_probability}
              closeNeighborhoodFocus={closeNeighborhoodFocus}
              closeHexFocus={closeHexFocus}
              neighborhoods={neighborhoods}
              neighborhoods_samples={neighborhoods_samples}
              setActiveNeighborhood={setActiveNeighborhood}
              interpolators={interpolators}
              top_space={top_space}
              active_hex={active_hex}
              browser_width={browser_width}
            />
          </div>
        ) : (
          active_neighborhood && neighborhoods_samples && (!mobile || mobile_show === 'info') ? (
            <div className="relative">
              <NeighborhoodFocus
                active_neighborhood={active_neighborhood}
                active_mode={active_mode}
                formatters={formatters}
                active_year={active_year}
                active_price={active_price}
                active_probability={active_probability}
                closeNeighborhoodFocus={closeNeighborhoodFocus}
                neighborhoods={neighborhoods}
                neighborhoods_samples={neighborhoods_samples}
                setActiveNeighborhood={setActiveNeighborhood}
                interpolators={interpolators}
                top_space={top_space}
                browser_width={browser_width}
              />
            </div>
          ) : (
            !mobile || (mobile && mobile_show === 'info')  ? (
              <div>
                {neighborhoods && neighborhoods_samples ? (
                  active_mode === 'Price' ? (
                    <QuestionProbList
                      neighborhoods={neighborhoods}
                      interpolators={interpolators}
                      formatters={formatters}
                      setActiveNeighborhood={setActiveNeighborhood}
                      setBoroughFilter={setBoroughFilter}
                      borough_filter={borough_filter}
                      top_space={top_space}
                      changePriceFocus={changePriceFocus}
                      price_focus={price_focus}
                      browser_width={browser_width}
                    />
                  ) : (
                    <QuestionPriceList
                      neighborhoods={neighborhoods}
                      interpolators={interpolators}
                      formatters={formatters}
                      changeProbabilityFocus={changeProbabilityFocus}
                      probability_focus={probability_focus}
                      setActiveNeighborhood={setActiveNeighborhood}
                      setBoroughFilter={setBoroughFilter}
                      borough_filter={borough_filter}
                      top_space={top_space}
                      browser_width={browser_width}
                    />
                  )
                ) : null}
              </div>
            ) : null
          )
        )}
        <div className="border-right top-0 bottom-0 fixed"
          style={{
            left: mobile ? '100%' : '360px',
            width: '1px'
          }}
        ></div>
      </div>
    </div>
  )
}

export default Sidebar2;


/** WEBPACK FOOTER **
 ** ./src/components/Sidebar2.js
 **/